import { createSlice } from "@reduxjs/toolkit";
import {   shareEmailReportThunk } from "./thunk";


export const initialState = {
  shareEmailReportData: [],
  shareEmailReportError: {
    code: null,
    message: '',
    data: null
  },
  shareEmailLoading: false,
  
  
};

const Share_Email_Report = createSlice({
  name: "Share_Email_Report",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(shareEmailReportThunk.pending, (state) => {
      state.shareEmailLoading = true ;
      state.shareEmailReportError = initialState.error; 
      state.shareEmailReportData = [];
  });
    builder.addCase(shareEmailReportThunk.fulfilled, (state, action) => {
        state.shareEmailReportData = action.payload.data;
        state.shareEmailLoading = false ;
    });
    builder.addCase(shareEmailReportThunk.rejected, (state, action) => {
      state.shareEmailReportError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.shareEmailLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Share_Email_Report.actions

export default Share_Email_Report.reducer;